import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  container: {
    paddingBottom: 60,

    [theme.breakpoints.down('sm')]: {
      paddingTop: 60,
      paddingBottom: 30,
    },
  },
  title: {
    color: '#77CC21',
    fontSize: 40,
    fontWeight: 'bold',

    [theme.breakpoints.down('sm')]: {
      fontSize: 24,
    },
  },
}));
